/**
 * Handles page lifecycle events (first load, reload, visibility changes, etc.)
 */

import { debugLog } from './debugLogger';

// Constants for storage
const PAGE_RELOAD_KEY = 'idleFleetPageReloadTime';
const PAGE_FIRST_LOAD_KEY = 'idleFleetFirstLoadTime';

/**
 * Detects if this is a page reload versus first load
 * @returns Information about the page load
 */
export const detectPageLoadType = () => {
  const now = Date.now();
  const isReload = sessionStorage.getItem(PAGE_RELOAD_KEY) !== null;
  
  // Update reload time (this will be null on first load in a session)
  sessionStorage.setItem(PAGE_RELOAD_KEY, now.toString());
  
  // If this is the first load ever, store that timestamp in localStorage
  if (!localStorage.getItem(PAGE_FIRST_LOAD_KEY)) {
    localStorage.setItem(PAGE_FIRST_LOAD_KEY, now.toString());
    debugLog('First ever load of the application');
  }
  
  // Calculate time since first load
  const firstLoadTime = parseInt(localStorage.getItem(PAGE_FIRST_LOAD_KEY) || now.toString());
  const timeSinceFirstLoad = now - firstLoadTime;
  
  debugLog(`Page ${isReload ? 'reloaded' : 'loaded for the first time'} this session. Time since first ever load: ${Math.floor(timeSinceFirstLoad / 1000)}s`);
  
  return {
    isReload,
    timeSinceFirstLoad,
    timestamp: now
  };
};

/**
 * Setup browser storage event listener to detect changes across tabs
 * @param callback Function to call when storage changes
 */
export const setupStorageListener = (callback: (event: StorageEvent) => void) => {
  window.addEventListener('storage', callback);
  return () => window.removeEventListener('storage', callback);
};
